import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { ButtonColor, ButtonShape, ButtonVariant } from '../../enums';
import { Button } from '../Button';
import styles from './SelectButton.module.scss';
const SelectButton = ({ className, color = ButtonColor.BrandDark, dataTestId, defaultSelected, onChange, options, shape = ButtonShape.Rounded, ...restProps }) => {
    const [selectedButton, setSelectedButton] = useState(defaultSelected ?? options?.[0].value);
    const onClick = (selected) => {
        setSelectedButton(selected);
        onChange(selected);
    };
    const isActive = useCallback((value) => {
        return selectedButton === value;
    }, [selectedButton]);
    return (_jsx("div", { className: classNames('d-inline-flex overflow-hidden', styles.buttonGroup, className, styles[color], styles[shape]), "data-testid": dataTestId, children: options.map((option, index) => (_jsxs(Button, { variant: isActive(option.value) ? ButtonVariant.Contained : ButtonVariant.Ghost, onClick: () => onClick(option.value), className: classNames(styles.button, {
                [styles.emptyButton]: !option.text,
                [styles.active]: isActive(option.value),
                [styles.first]: index === 0,
                [styles.last]: index === options.length - 1,
            }), shape: shape, color: color, ...restProps, a11yText: option.a11yText, children: [option.icon && (_jsx(option.icon, { className: classNames({
                        'mr-0': !option.text,
                        'mr-1x': !!option.text,
                    }) })), option.text] }, option.value))) }));
};
export { SelectButton };
